<template>
  <div class="navbar">
    <span class="url blink-3">{{ url }}</span>
  </div>
  <img class="img1" src="@/assets/img/shoucang.jpg" alt="" />
  <p class="text0 text1 text-shadow-pop-tl blink-3">
    【曾道人内幕网】每日更新，提供最新的六合资讯、开奖结果、历史数据、专家预测等内容，助您掌握第一手信息，提升中奖概率！每天更新，敬请关注！
  </p>
  <div class="head1"></div>
</template>

<script setup>
import typeTableIcon from "@/assets/img/typeTableIcon.png";
import logo from "@/assets/img/logo.png";
import { useRouter } from "vue-router";
const router = useRouter();

const url = window.location.hostname;

function share() {
  if (navigator.share) {
    navigator
      .share({
        title: "淘码论坛",
        text: "",
        url: window.location.href,
      })
      .then(() => console.log("Share successful"))
      .catch((error) => console.log("Error sharing:", error));
  } else {
    alert("当前浏览器不支持分享");
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  font-weight: bold;
  padding: 10px 16px;
  // background-color: #a100a0;
  background-image: url("../assets/img/11.png");
  background-size: 100% 100%;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 999;
  font-family: "Courier New", Courier, monospace;
  position: relative;
  height: 70px;

  .url {
    position: absolute;
    left: 85px;
    top: 50px;
    font-size: 20px;
    font-weight: bold;
  }
}
.text0 {
  text-align: center;
  color: #c96d10;
  font-weight: bold;
  font-size: 20px;
  padding: 12px 0;
}
.text1 {
  color: #ff2900;
}
.title {
  width: 100%;
  height: 100px;
}
.img1 {
  width: 100%;
  height: 60px;
}
.head {
  width: 100vw;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  padding: 6px 10px;
  background-color: #fc9078;
  display: flex;
  flex: 1;
  justify-content: space-between;
  > div {
    width: 33.333%;
  }
  .title {
    text-align: center;
    img {
      height: 35px;
    }
  }
  .right {
    text-align: right;
    img {
      height: 35px;
      width: 65px;
    }
  }
}
.head1 {
  position: relative;
  .mask {
    width: 230px;
    height: 30px;
    background-color: #d02928;
    position: absolute;
    top: 65px;
    left: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
      "Lucida Sans", Arial, sans-serif;
    background-color: aliceblue;
    color: #fc9078;
    border-radius: 6px;
  }
}
.demo {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 20px;
}

/* 双色闪烁 */
.blink-1 {
  animation: blink1 0.8s infinite;
}
@keyframes blink1 {
  0%,
  100% {
    color: #ff0000;
  }
  50% {
    color: #00ff00;
  }
}

/* 三色闪烁 */
.blink-2 {
  animation: blink2 0.3s infinite;
  font-size: 25px;
  font-weight: bold;
}
@keyframes blink2 {
  0%,
  100% {
    color: #ff0000;
  }
  50% {
    color: #0000ff;
  }
}

/* 明灭闪烁 */
.blink-3 {
  animation: blink3 0.5s steps(2) infinite;
}
@keyframes blink3 {
  0%,
  100% {
    color: #a7ae03;
  }
  50% {
    color: red;
  }
}
</style>